/** Detect which brand experience to serve based on hostname */
export function isSLAWDomain(): boolean {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname.toLowerCase();
  if (host.includes('slawscore') || host.includes('slaw-score')) return true;
  // Dev/preview override: allow forcing SLAW brand on lovable.app preview hosts
  try {
    if (window.localStorage.getItem('force_brand') === 'slaw') return true;
    const params = new URLSearchParams(window.location.search);
    if (params.get('brand') === 'slaw') {
      window.localStorage.setItem('force_brand', 'slaw');
      return true;
    }
    if (params.get('brand') === 'boltway') {
      window.localStorage.removeItem('force_brand');
    }
  } catch {
    // ignore storage errors
  }
  return false;
}

/** Get the brand context */
export function getBrand() {
  const slaw = isSLAWDomain();
  return {
    isSLAW: slaw,
    name: slaw ? 'SLAW Score™' : 'Boltway™',
    tagline: slaw ? 'The FICO Score for Entity Data Quality' : 'Autonomous Integration & Intelligence Platform',
    homeRoute: slaw ? '/slaw-index' : '/home',
  };
}
